import styled from 'styled-components'

import { palette } from '../../../../styles/variables'

export default styled.div({
  color: palette.orange,
  fontSize: 16,
  transform: 'translateY(10%)',
})
